import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAppStore } from "@/hooks/useAppStore";
import { useTranslation } from "@/lib/translate";
import { Language } from "@/types";

interface LanguageSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const LanguageSettingsDialog: React.FC<LanguageSettingsDialogProps> = ({
  open,
  onOpenChange,
}) => {
  const preferredLanguage = useAppStore((state) => state.preferredLanguage);
  const setPreferredLanguage = useAppStore((state) => state.setPreferredLanguage);
  const t = useTranslation(preferredLanguage);

  const updatePreferredLanguage = (language: Language) => (ev: React.SyntheticEvent) => {
    ev.preventDefault();
    setPreferredLanguage(language);
    onOpenChange(false);
    return false;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] bg-neutral-800 border-neutral-700 text-white">
        <DialogHeader>
          <DialogTitle className="text-center text-lg">
            {t("Language Settings")}
          </DialogTitle>
        </DialogHeader>
        <div className="flex justify-center py-4">
          <div className="flex flex-col">
            <div className="mt-4 bg-gradient-to-r from-orange-300 to-orange-500 rounded-full p-1 hover:scale-105">
              <button
                type="button"
                className="flex items-center justify-center text-white text-sm md:text-base border-white min-w-40 rounded-full bg-transparent hover:bg-transparent shadow-md transition-transform px-5 md:px-9 py-1 md:py-2 border-1"
                onClick={updatePreferredLanguage("ja")}
              >
                日本語
                <span className="ml-3">
                  <ChevronRight />
                </span>
              </button>
            </div>
            <div className="mt-4 bg-gradient-to-r from-orange-300 to-orange-500 rounded-full p-1 hover:scale-105">
              <button
                type="button"
                className="flex items-center justify-center text-white text-sm md:text-base border-white min-w-40 rounded-full bg-transparent hover:bg-transparent shadow-md transition-transform px-5 md:px-9 py-1 md:py-2 border-1"
                onClick={updatePreferredLanguage("en")}
              >
                English
                <span className="ml-3 flex items-center" >
                  <ChevronRight />
                </span>
              </button>
            </div>
            <div className="mt-4 bg-gradient-to-r from-orange-300 to-orange-500 rounded-full p-1 hover:scale-105 mb-5">
              <button
                type="button"
                className="flex items-center justify-center text-white text-sm md:text-base border-white min-w-40 rounded-full bg-transparent hover:bg-transparent shadow-md transition-transform px-5 md:px-9 py-1 md:py-2 border-1"
                onClick={updatePreferredLanguage("zh")}
              >
                中文
                <span className="ml-3">
                  <ChevronRight />
                </span>
              </button>
            </div>
          </div>
        </div>
        <DialogFooter className="sm:justify-center">
          <Button
            type="button"
            variant="secondary"
            onClick={() => onOpenChange(false)}>
            {t("Close")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
